<div *ngIf="loaderService.isLoading | async" id="pause" class="d-flex align-items-center justify-content-center">
    <div id="spinner"></div>
</div>
<div class="modal-header bg-primary">
    <h4 class="modal-title"  style="color: white;">L288 Measure Grid</h4>
  </div>
  <div class="modal-body">
    <!-- <p>{{cModalBody}}</p> -->
  <!---==============================================================================
        HEADER
    ===============================================================================--->
    <div id="measureGrid">
        <div class="row">
            <div class="col-md-12 ">
                <p>
                    When selecting L188 and location is 'in-city', creation of a L288 fund/class account is required. 
                    Please enter appropriate measures for each applicable tax period.
                <p>
            </div>
        </div>
        <!-- <form [formGroup]="fForm"> -->
            <div class="row">
                <div class="col-md-12 table-responsive">
                                        <table class="table table-bordered"  style="width: 100%;">
                                            <thead>
                                                <tr class="colHd1">
                                                    <th>Fund Class</th>
                                                    <th>Tax Period</th>
                                                    <th>Date From</th>
                                                    <th>Date To</th>
                                                    <th>Basis For Tax</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                 <tr *ngFor="let qfundClassGrid of trcFundClass let i = index">
                                                    <td>{{qfundClassGrid.revenue_type}} - {{qfundClassGrid.description}}</td>
                                                    <td>{{qfundClassGrid.taxPeriod}}</td>
                                                    <td>{{qfundClassGrid.dateFrom | date:"MM/dd/yyy"}}</td>
                                                    <td>{{qfundClassGrid.dateTo | date:"MM/dd/yyy"}}</td>
                                                    <td ><input type="text"  min="0" name="measure" (change)="calculateTotalMeasuress(qfundClassGrid ,$event)" (change)="addMeasure(qfundClassGrid ,$event)"      
                                                    value="{{qfundClassGrid.measure}}" maxlength="10" id="measure_{{i}}" 
                                                    	 onkeypress="return event.charCode>=48 && event.charCode <= 57"></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
            </div>
        <!-- </form> -->
    </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="OK()">OK</button>
    </div>
    

